import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import acknowledgeSolarEdgeAlert, {
  AcknowledgeSolarEdgeAlertRequest,
} from "../http/acknowledgeSolarEdgeAlert";
import deleteSolarEdgeAlertAcknowledgement from "../http/deleteSolarEdgeAlertAcknowledgement";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

export const useSolarEdgeAlertAcknowledgement = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  const queryClient = useQueryClient();

  const invalidate = (siteId: string) => {
    queryClient.invalidateQueries(["siteHealthEvents", siteId]);
    queryClient.invalidateQueries(["healthEventsInRange"]);
  };

  const acknowledge = useMutation(
    async ({
      siteId,
      alertId,
      ...request
    }: {
      siteId: string;
      alertId: number;
    } & AcknowledgeSolarEdgeAlertRequest) => {
      const token = await getAuthTokenBlocking(getToken, relogin);
      return acknowledgeSolarEdgeAlert(token, siteId, alertId, request);
    },
    { onSuccess: (_data, { siteId }) => invalidate(siteId) }
  );

  const unacknowledge = useMutation(
    async ({ siteId, alertId }: { siteId: string; alertId: number }) => {
      const token = await getAuthTokenBlocking(getToken, relogin);
      return deleteSolarEdgeAlertAcknowledgement(token, siteId, alertId);
    },
    { onSuccess: (_data, { siteId }) => invalidate(siteId) }
  );

  return { acknowledge, unacknowledge };
};
